module.exports = __webpack_public_path__ + "img/3.e1e40b30.png";